import { FC } from 'react';

import { FileBrowserStorageObjectFragment } from '../../../graphql/generated';
import { isFile } from '../../../graphql/utils/utils';
import { FileStatusBadge } from '../../file/file-status-badge';
import {
  PiiStatusBadge,
  shouldDisplayBadgeForPiiStatus,
} from '../../file/pii-status-badge';
import {
  shouldDisplayBadgeForVirusStatus,
  VirusStatusBadge,
} from '../../file/virus-status-badge';
import { Placeholder } from '../file-browser';

type Props = {
  object: FileBrowserStorageObjectFragment;
};

export const FileStatus: FC<Props> = ({ object }) => {
  if (!isFile(object)) {
    return null;
  }

  const { status, virusStatus, piiStatus } = object;
  const testId = {
    'data-testid': 'status-badge',
  };

  if (virusStatus && shouldDisplayBadgeForVirusStatus(virusStatus)) {
    return <VirusStatusBadge virusStatus={virusStatus} {...testId} />;
  }

  if (piiStatus && shouldDisplayBadgeForPiiStatus(piiStatus)) {
    return <PiiStatusBadge piiStatus={piiStatus} {...testId} />;
  }

  if (status) {
    return <FileStatusBadge status={status} {...testId} />;
  }

  return <Placeholder {...testId} />;
};
